import { getApiEmployeesMine, getApiBusinessesById } from '~/src/client'

export default defineNuxtRouteMiddleware(async (to) => {
  const { isAuthenticated, isAuthReady, businessStatus, isAdmin } = useAuth()
  
  // Wait for auth to be ready
  if (!isAuthReady.value) return

  const publicPages = ['/', '/register', '/oauth/callback']

  if (!isAuthenticated.value) {
     if (!publicPages.includes(to.path)) {
        return navigateTo('/')
     }
     return
  }

  // Admin users are allowed to go anywhere and don't get trapped in onboarding
  if (isAdmin.value) return
  try {
    const { data: employments } = await getApiEmployeesMine()
    if (!employments || employments.length === 0) {
       // User has no business?
       return 
    }

    // Fetch all business statuses
    const businesses = await Promise.all(
      employments.map(e => getApiBusinessesById({ path: { id: e.business_id! } }).then(r => r.data))
    )

    // Check if any business is Active
    const hasActive = businesses.some(b => b?.status === 'Active')
    if (hasActive) {
      businessStatus.value = 'Active'
      if (to.path.startsWith('/onboarding') || to.path === '/register') {
        return navigateTo('/')
      }
      return
    }

    // Check if any business is PendingVerification
    const hasPending = businesses.some(b => b?.status === 'PendingVerification')
    if (hasPending) {
      businessStatus.value = 'PendingVerification'
      if (to.path !== '/onboarding/waiting-room') {
        return navigateTo('/onboarding/waiting-room')
      }
      return
    }

    // If we reach here, all businesses are in Draft or Inactive
    const hasDraft = businesses.some(b => b?.status === 'Draft')
    if (hasDraft) {
      businessStatus.value = 'Draft'
      if (to.path !== '/onboarding/upload') {
        return navigateTo('/onboarding/upload')
      }
      return
    }

    businessStatus.value = businesses[0]?.status || null
  } catch (e) {
    console.error('Middleware error', e)
    // On error, maybe allow proceed or redirect to error page
  }
})

